export default {
  apiHostUrl: process.env.VUE_APP_API_HOST_URL,
  apiVersion: process.env.VUE_APP_API_VERSION,

  getApiHost() {
    return `${this.apiHostUrl}/${this.apiVersion}`
  },
}
